import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { BadgeCheck, Gauge } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { orgLabel } from "@/lib/constants";

export default function TrustScoresTab() {
  const [trust, setTrust] = useState([]);

  const load = useCallback(() => {
    api.get("/admin/trust-scores").then(({ data }) => setTrust(data.profiles)).catch(() => {});
  }, []);

  useEffect(() => { load(); }, [load]);

  const saveTrust = async (uid, val) => {
    try { await api.post("/admin/trust-score", { profile_user_id: uid, trust_score: Number(val) }); toast.success("Trust score updated"); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  return (
    <div className="border border-slate-200 bg-white rounded-lg overflow-x-auto" data-testid="admin-trust-table">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-xs uppercase tracking-wider text-slate-400 border-b border-slate-100">
            <th className="px-4 py-3 font-semibold">Business</th>
            <th className="px-4 py-3 font-semibold">Type</th>
            <th className="px-4 py-3 font-semibold">Verified</th>
            <th className="px-4 py-3 font-semibold">Trust score</th>
            <th className="px-4 py-3 font-semibold text-right">Adjust</th>
          </tr>
        </thead>
        <tbody>
          {trust.map((p) => (
            <tr key={p.user_id} className="border-b border-slate-50 last:border-0">
              <td className="px-4 py-3 font-medium text-[#0A0F1C]">{p.org_name || "—"}</td>
              <td className="px-4 py-3 text-slate-500">{orgLabel(p.org_type)}</td>
              <td className="px-4 py-3">{p.verified ? <BadgeCheck size={15} className="text-[#2563EB]" /> : <span className="text-slate-300">—</span>}</td>
              <td className="px-4 py-3">
                <div className="flex items-center gap-2">
                  <Gauge size={14} className={p.trust_score >= 70 ? "text-green-500" : p.trust_score >= 40 ? "text-amber-500" : "text-red-500"} />
                  <div className="w-28 h-2 rounded-full bg-slate-100 overflow-hidden"><div className="h-full bg-[#2563EB]" style={{ width: `${p.trust_score}%` }} /></div>
                  <span className="font-mono text-xs text-slate-600">{p.trust_score}</span>
                </div>
              </td>
              <td className="px-4 py-3 text-right">
                <input type="number" min="0" max="100" defaultValue={p.trust_score} data-testid={`trust-input-${p.user_id}`}
                  onBlur={(e) => e.target.value !== String(p.trust_score) && saveTrust(p.user_id, e.target.value)}
                  className="w-20 h-8 px-2 rounded border border-slate-300 text-sm font-mono focus:ring-2 focus:ring-[#2563EB] outline-none" />
              </td>
            </tr>
          ))}
          {trust.length === 0 && <tr><td colSpan={5} className="px-4 py-10 text-center text-slate-400">No profiles yet</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
